import { createContext } from 'react';
import { IBaseOverlayScrollbar } from './interface';

export const BaseOverlayScrollbarContext = createContext<IBaseOverlayScrollbar.Context>({
	current: undefined,
});
